import { useProductContext } from "./productContext.mjs";
import { useAppRouter } from "./router.mjs";
import { usesSetProductConfiguration } from "./config/product-configurations.mjs";
import { serializeObjectToParams } from "../../../dist/runtime/utils/route";
import { isEmpty, omit } from "lodash-es";
import { computed, onMounted, ref, watch } from "vue";
import { useRoute } from "#app";
export function useProductConfigurationOptions() {
  const { getProductConfiguration } = usesSetProductConfiguration();
  const { product, productCtx, appendProductValues } = useProductContext();
  const selectedOptions = ref();
  const route = useRoute();
  const { redirect, query } = useAppRouter();
  const productMap = ref(/* @__PURE__ */ new Map());
  const selectedVariant = computed(() => {
    const variantSlug = route.params.slug.at(-1);
    return productCtx.value?.variants?.find(
      (variant) => variant.slug === variantSlug
    ) || null;
  });
  const unwatch = watch(
    productCtx,
    (newProduct) => {
      if (newProduct) {
        productMap.value = generateMap(
          productCtx.value,
          productCtx.value.configurationOptions?.map(
            (option) => option?.attribute_code || ""
          ) || []
        );
        setTimeout(() => unwatch());
      }
    },
    {
      immediate: true
    }
  );
  const productOptions = computed(() => {
    if (getProductConfiguration() === "fist-only") {
      const selectedValues = Object.values(selectedOptions.value || {});
      const selectedKeys = Object.keys(selectedOptions.value || {});
      const alteredProductMap = Array.from(productMap.value.values()).filter(
        (option) => {
          return option.includes(selectedValues[0]);
        }
      );
      return productCtx.value?.configurationOptions?.map((option) => {
        return {
          ...option,
          values: option?.values?.map((value) => {
            const active = selectedValues.length === 0 || option?.attribute_code === selectedKeys[0] ? isContainItems(
              [String(value?.uid)],
              Array.from(productMap.value.values())
            ) : isContainItems(
              [
                ...Object.values(
                  omit(
                    selectedOptions.value,
                    selectedOptions.value?.[String(option?.attribute_code)] ? String(option?.attribute_code) : ""
                  )
                ),
                String(value?.uid)
              ],
              alteredProductMap
            );
            return {
              ...value,
              active
            };
          })
        };
      });
    }
    return productCtx.value?.configurationOptions?.map((option) => {
      return {
        ...option,
        values: option?.values?.map((value) => {
          return {
            ...value,
            active: isEmpty(selectedOptions.value) || selectedOptions.value?.[option?.attribute_code ?? ""] && Object.values(selectedOptions.value).find(
              (option2) => value?.uid === option2
            ) ? true : isContainItems(
              [
                ...Object.values(
                  omit(
                    selectedOptions.value,
                    selectedOptions.value?.[option?.attribute_code ?? ""] ? option?.attribute_code ?? "" : ""
                  )
                ),
                value?.uid || ""
              ],
              Array.from(productMap.value.values())
            )
          };
        })
      };
    });
  });
  watch(
    selectedVariant,
    (newSelectedVariant) => {
      if (!newSelectedVariant) {
        appendProductValues({
          name: productCtx.value.name,
          price: productCtx.value.price,
          parentSku: void 0
        });
        return;
      }
      if (newSelectedVariant) {
        appendProductValues({
          sku: newSelectedVariant.sku ?? "",
          name: newSelectedVariant.name,
          price: newSelectedVariant.price,
          media_gallery: newSelectedVariant.media_gallery,
          thumbnail: newSelectedVariant.thumb ?? {
            url: productCtx.value?.thumbnail?.url || "",
            label: productCtx.value?.thumbnail?.label || ""
          },
          parentSku: productCtx.value.sku ?? "",
          type: newSelectedVariant.type,
          stock: newSelectedVariant.stock
        });
        selectedOptions.value = {
          ...selectedOptions.value,
          ...newSelectedVariant.attributes?.reduce(
            (accu, curr) => ({ ...accu, [curr?.code ?? ""]: curr?.uid ?? "" }),
            {}
          )
        };
      }
    },
    {
      immediate: true
    }
  );
  watch(selectedOptions, (options) => {
    if (options && !Object.keys(options).length) {
      redirect(
        `/${product.value?.url_key}${serializeObjectToParams(query.value)}`
      );
      return;
    }
    if (options) {
      const matchedVariant = product.value?.variants?.find((variant) => {
        return Object.keys(options).every((option) => {
          return variant.attributes?.find(
            (attribute) => attribute?.uid === selectedOptions.value?.[option]
          );
        });
      });
      if (matchedVariant) {
        redirect(
          `/${product.value?.url_key}/var/${matchedVariant?.slug}${serializeObjectToParams(query.value)}`
        );
      }
    }
  });
  onMounted(() => {
    if (!selectedOptions.value) {
      redirect(
        `/${product.value?.url_key}/var/${product.value.variants?.[0]?.slug}${serializeObjectToParams(query.value)}`
      );
    }
  });
  return {
    productOptions,
    selectedOptions,
    route,
    selectedVariant
  };
}
function generateMap(product, allowedAttributes) {
  const result = /* @__PURE__ */ new Map();
  product.variants?.forEach((variant) => {
    const uids = variant.attributes?.filter(
      (attribute) => attribute?.code && allowedAttributes.find((attr) => attr === attribute?.code)
    )?.map((attribute) => attribute?.uid || "");
    result.set(variant?.id?.toString() || "", uids || []);
  });
  return result;
}
function isContainItems(op, index) {
  return index.some(
    (item) => op.every((existedProperty) => item.includes(existedProperty))
  );
}
